import { render, staticRenderFns } from "./DepartmentIndex.vue?vue&type=template&id=bc7f8672&scoped=true&"
import script from "./DepartmentIndex.vue?vue&type=script&lang=js&"
export * from "./DepartmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentIndex.vue?vue&type=style&index=0&id=bc7f8672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7f8672",
  null
  
)

export default component.exports